import React from 'react'
import PropTypes from 'prop-types'

/**
 * Menu overlay for the sidebar menu
 *
 * @param {bool} props.isVisible - Whether the overlay is visible or not
 * @param {function} props.onClick - onclick callback
 * @param {integer} props.zIndex - zIndex value for style
 *
 * @returns {function} React Functional component
 */
const MenuOverlay = ({ isVisible, onClick, zIndex }) => {
  return (
    <div
      className={`menu-overlay ${isVisible ? 'is-visible' : 'is-hidden'}`}
      onClick={onClick}
      style={{ zIndex: zIndex }}
    />
  )
}

MenuOverlay.defaultProps = {
  isVisible: false,
  zIndex: 1000000,
}

MenuOverlay.propTypes = {
  isVisible: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  zIndex: PropTypes.number,
}

export default MenuOverlay
